// extracted by mini-css-extract-plugin
export default {"override-row":"YuXRDb6kI3vN4OGSgKJo","has-override":"_LTrstNmDBXAcRVAeW0c","override-row-root":"gZ0A_7meTlFDWgUqaHV_"};